// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__WHeXz","title":"Info_title__EBBEI","selects":"Info_selects__3I5SA","requiredAsterisk":"Info_requiredAsterisk__2UVIC"};